import React, { useState } from "react";
import styles from "./IGImageDetails.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { SearchInput, SubmitButton, TextComponent } from "../../../components";
import shareImg from "../../../assets/shareImg.png";
import share from "../../../assets/share.png";
import deleteImg from "../../../assets/deleteImg.png";
import edit from "../../../assets/edit.png";
import download from "../../../assets/downloadIcon2.png";
import Modal from "../../../components/modal/Modal";
import { useRef } from "react";
import CopyLinkModal from "../../../components/copyLinkModal/CopyLinkModal";
import { roles } from "../../../config/roles";
import Storage from "../../../utills/AsyncStorage";
import { useDispatch } from "react-redux";
import { InspirationalGalleryMiddleware } from "../../../Store/Middlewares/InspirationalGalleryMiddleware";
import { PhotosMiddleware } from "../../../Store/Middlewares/PhotosMiddleware";
import { saveAs } from "file-saver";

const IGImageDetails = ({ item, setDeleteImgModal, setDeleteId }) => {
  const [shareImgModal, setShareImgModal] = useState(false);
  const [copyModal, setCopyModal] = useState(false);
  const navigation = useNavigate();
  // const role = localStorage.getItem("role");
  const role = Storage.getERole("@role");
  const { state } = useLocation();
  console.log("stateeeeeIG", state);
  const dispatch = useDispatch();

  const onMoveToGallery = () => {
    dispatch(
      PhotosMiddleware.MoveIGPhotosToGallery({
        event_id: state?.event_id,
        id: item?.id,
      })
    )
      .then(() => {
        setShareImgModal(false);
      })
      .catch(() => {
        setShareImgModal(false);
      });
  };
  function downloadImage(src, name) {
    const href = `https://www.bestdayever.me/api/downloadFile?path=${src}`;
    const anchorElement = document.createElement("a");
    anchorElement.href = href;
    anchorElement.download = `${name}`;
    document.body.appendChild(anchorElement);
    anchorElement.click();
    document.body.removeChild(anchorElement);
  }
  const filename = item?.image?.substring(item?.image?.lastIndexOf("/") + 1);
  return (
    <div className={styles.mainCon}>
      <div className={styles.header}>
        {/* <TextComponent
          // text={item?.name ? item?.name : "--"}
          textClass={styles.headTxt}
        /> */}
        {role == roles.vendor || role == roles.staff ? (
          <div>
            <div
              className={styles.imageDiv}
              // onClick={() => setShareImgModal(true)}
              onClick={() => downloadImage(item?.image, filename)}
            >
              <img src={download} className={styles.image} />
            </div>
          </div>
        ) : (
          <div>
            {/* <div
              className={styles.imageDiv}
              onClick={() => setShareImgModal(true)}
            >
              <img src={shareImg} className={styles.image} />
            </div> */}
            {/* <div className={styles.imageDiv} onClick={() => setCopyModal(true)}>
              <img src={share} className={styles.image} />
            </div> */}
            <div
              className={styles.imageDiv}
              onClick={() => {
                setDeleteId(item.id);
                setDeleteImgModal(true);
              }}
            >
              <img src={deleteImg} className={styles.image} />
            </div>
            {/* <div
              className={styles.editImageDiv}
              onClick={() =>
                navigation("/events/createInspirationalGallery", {
                  state: {
                    headrTitle: "Edit Inspirational Gallery",
                    state,
                    screenType: "Edit",
                    event_id: state?.event_id,
                  },
                })
              }
            >
              <img src={edit} className={styles.editImage} />
            </div> */}
          </div>
        )}
      </div>
      <div className={styles.categoryImgDiv}>
        <img src={item?.image} />
      </div>
      {/* Share Modal */}
      {/* <Modal
        isModalOpen={shareImgModal}
        setIsModalOpen={setShareImgModal}
        closable={true}
        className={styles.shareImgModal}
        pinkBg={true}
      >
        <div className={styles.modalDiv}>
          <svg
            viewBox="0 0 220 239"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M211.827 114.856C207.363 114.019 203.506 113.302 200.483 112.747C198.208 109.497 196.561 106.443 194.264 103.975C185.683 94.7472 176.896 85.7037 167.752 76.1385C164.317 79.4863 161.76 81.9102 159.268 84.4102C134.024 109.617 108.779 134.823 83.5349 160.03C77.4893 166.062 74.7915 166.128 68.8 159.997C59.3739 150.334 50.0562 140.552 39.6334 129.715C31.0199 138.736 23.1973 146.867 15.4723 155.073C14.8222 155.769 14.4105 156.986 14.3997 157.965C14.3239 168.041 14.3564 178.117 14.3564 188.715C41.9736 188.715 69.2225 188.715 96.4497 188.715C98.1291 193.345 99.6459 197.508 101.412 202.367C99.3642 202.465 97.5007 202.617 95.648 202.617C69.9268 202.628 44.2055 202.628 18.4843 202.617C5.48286 202.595 0.943183 198.139 0.932348 185.062C0.921513 128.943 0.943183 72.8124 1.00819 16.6927C1.01902 4.77969 5.50453 0.268813 17.26 0.257943C76.7959 0.236204 136.332 0.247074 195.878 0.268813C207.482 0.268813 212.011 4.59491 212.054 16.1819C212.174 47.9428 212.109 79.7037 212.109 111.465C212.109 112.53 211.935 113.584 211.827 114.856ZM62.0392 35.9754C51.7681 35.6928 43.5988 43.3341 43.3496 53.4537C43.1004 63.7145 50.7604 71.845 60.8907 72.0732C71.021 72.3015 79.1361 64.4863 79.3528 54.3232C79.5695 44.4536 71.8228 36.2471 62.0392 35.9754Z"
              fill="var(--primary-color)"
            />
            <path
              d="M184.999 202.705C193.482 196.694 202.009 195.313 210.752 201.281C218.943 206.879 221.869 217.063 218.109 226.15C214.339 235.259 205.205 240.281 195.4 238.64C186.266 237.107 178.704 229.009 178.574 219.531C178.52 215.357 176.884 213.509 173.536 211.835C167.75 208.955 162.062 205.846 156.526 202.531C153.459 200.694 151.325 200.346 148.031 202.737C139.169 209.172 127.911 208.574 119.45 202.009C111.302 195.694 108.052 184.661 111.432 174.803C116.665 159.509 135.398 153.422 148.573 162.987C151.206 164.9 152.95 165.053 155.648 163.455C161.834 159.803 168.151 156.357 174.554 153.118C177.469 151.639 178.487 149.857 178.617 146.487C178.996 136.139 185.963 128.542 196.028 126.726C204.728 125.161 214.241 130.389 218.012 138.824C221.825 147.346 219.203 157.694 211.717 163.65C205.032 168.966 196.169 169.205 187.913 164.781C186.288 163.911 183.504 163.813 181.868 164.629C174.955 168.053 168.249 171.911 161.509 175.694C157.338 178.042 157.284 187.531 161.444 189.846C169.299 194.205 177.198 198.455 184.999 202.705ZM145.182 182.868C145.203 176.716 140.404 171.77 134.423 171.781C128.529 171.792 123.502 176.922 123.556 182.868C123.61 188.683 128.323 193.433 134.163 193.563C140.339 193.694 145.16 189.009 145.182 182.868ZM199.246 140.107C195.216 140.042 192.085 143.096 192.03 147.15C191.965 151.205 194.988 154.303 199.062 154.346C203.103 154.4 206.289 151.346 206.354 147.346C206.408 143.433 203.201 140.161 199.246 140.107ZM199.398 211.227C195.4 211.161 192.204 214.237 192.15 218.216C192.095 222.281 195.151 225.542 199.073 225.607C202.832 225.672 206.256 222.346 206.419 218.487C206.581 214.585 203.396 211.292 199.398 211.227Z"
              fill="var(--primary-color)"
            />
          </svg>
          <div className={styles.modalTxtDiv}>
            <TextComponent text={"Move Image to"} textClass={styles.modalTxt} />
            <TextComponent text={"Gallery"} textClass={styles.modalSubTxt} />
          </div>
          <SubmitButton
            title={"Move To Gallery"}
            btnClass={styles.modalBtn}
            onClick={onMoveToGallery}
          />
          <SubmitButton
            outline
            title={"Cancel"}
            btnClass={styles.modalBtn}
            onClick={() => setShareImgModal(false)}
          />
        </div>
      </Modal> */}
      {/* Delete Modal */}
      {/* Copy Modal */}
      {/* <CopyLinkModal
        isCopyModalOpen={copyModal}
        setIsCopyModalOpen={setCopyModal}
        link={item?.image}
      /> */}
    </div>
  );
};

export default IGImageDetails;
